import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { auth, db } from '../../firebase/config';
import { updatePassword, sendPasswordResetEmail } from 'firebase/auth';
import { doc, updateDoc } from 'firebase/firestore';
import toast from 'react-hot-toast';
import { PageTitle } from '../common/common.styles';
import { Input, Button } from '../common/Form.styles';
import { SettingsCard, CardTitle, HelperText, InlineLink } from './Settings.styles'; // <-- Import InlineLink

const Settings = () => {
  // Form for updating user's name
  const nameFormik = useFormik({
    initialValues: { clientName: auth.currentUser.displayName || '' },
    validationSchema: Yup.object({
      clientName: Yup.string().required('Name is required'),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      const user = auth.currentUser;
      const userDocRef = doc(db, 'users', user.uid);
      try {
        await updateDoc(userDocRef, { clientName: values.clientName });
        toast.success('Name updated successfully!');
      } catch (error) {
        toast.error('Failed to update name.');
        console.error(error);
      }
      setSubmitting(false);
    },
  });

  // Form for changing password
  const passwordFormik = useFormik({
    initialValues: { newPassword: '', confirmPassword: '' },
    validationSchema: Yup.object({
      newPassword: Yup.string().min(6, 'Password must be at least 6 characters').required('Required'),
      confirmPassword: Yup.string().oneOf([Yup.ref('newPassword'), null], 'Passwords must match').required('Required'),
    }),
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        await updatePassword(auth.currentUser, values.newPassword);
        toast.success('Password updated successfully! Please re-login.');
        resetForm();
        // In a real app, you would force a logout here.
      } catch (error) {
        toast.error('This operation is sensitive and requires recent login. Please log out and log back in to change your password.');
        console.error(error);
      }
      setSubmitting(false);
    },
  });
  
  const handlePasswordReset = () => {
    sendPasswordResetEmail(auth, auth.currentUser.email)
      .then(() => {
        toast.success('Password reset email sent! Check your inbox.');
      })
      .catch((error) => {
        toast.error('Failed to send reset email.');
        console.error(error);
      });
  };

  return (
    <div>
      <PageTitle>Account Settings</PageTitle>

      <SettingsCard>
        <CardTitle>Update Profile</CardTitle>
        <form onSubmit={nameFormik.handleSubmit}>
          <Input
            name="clientName"
            placeholder="Your Full Name"
            onChange={nameFormik.handleChange}
            value={nameFormik.values.clientName}
          />
          <Button type="submit" disabled={nameFormik.isSubmitting}>Save Name</Button>
        </form>
      </SettingsCard>

      <SettingsCard>
        <CardTitle>Change Password</CardTitle>
        <form onSubmit={passwordFormik.handleSubmit}>
          <Input
            name="newPassword"
            type="password"
            placeholder="New Password"
            onChange={passwordFormik.handleChange}
            value={passwordFormik.values.newPassword}
          />
          <Input
            name="confirmPassword"
            type="password"
            placeholder="Confirm New Password"
            onChange={passwordFormik.handleChange}
            value={passwordFormik.values.confirmPassword}
          />
          <Button type="submit" disabled={passwordFormik.isSubmitting}>Update Password</Button>
        </form>
        <HelperText>
          Forgot your password?{' '}
          {/* --- USE THE NEW COMPONENT HERE --- */}
          <InlineLink href="#" onClick={(e) => { e.preventDefault(); handlePasswordReset(); }}>
            Send reset link
          </InlineLink>
        </HelperText>
      </SettingsCard>
    </div>
  );
};

export default Settings;